module.exports = __webpack_public_path__ + "fonts/ethnocen-webfont.1970c59d.woff";